var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgQuestionMark = function SvgQuestionMark(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13,
    stroke: "#3D7C54",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3D7C54",
    d: "M14.397 6.88c1.32 0 2.386.373 3.2 1.12.813.747 1.22 1.747 1.22 3 0 1.4-.434 2.44-1.3 3.12-.867.667-2.04 1-3.52 1l-.06 1.9h-1.58l-.08-3.16h.58c1.32 0 2.353-.2 3.1-.6.746-.4 1.12-1.153 1.12-2.26 0-.8-.24-1.433-.72-1.9-.48-.467-1.127-.7-1.94-.7-.827 0-1.48.227-1.96.68-.467.44-.7 1.047-.7 1.82h-1.72c0-.8.18-1.5.54-2.1a3.638 3.638 0 0 1 1.52-1.42c.666-.333 1.433-.5 2.3-.5Zm-1.26 14.24c-.347 0-.64-.12-.88-.36s-.36-.533-.36-.88.12-.64.36-.88.533-.36.88-.36c.333 0 .613.12.84.36.24.24.36.533.36.88s-.12.64-.36.88a1.11 1.11 0 0 1-.84.36Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgQuestionMark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "question-mark.fca9925f9a73be680a1138c95b454227.svg";